import { devFeaturesStateSelector } from "@store/dev-features/dev-features-selector";
import { useAppSelector } from "@store/store-helper";
import { useEffect } from "react";

/**
 * Component that applies dark mode styling to the document root
 */
export function DarkModeApplier(): null {
  const { isDarkModeEnabled } = useAppSelector(devFeaturesStateSelector);

  /** Apply or remove dark mode attribute on document root based on dark mode setting */
  useEffect(() => {
    const root = document.documentElement;
    if (isDarkModeEnabled) {
      root.setAttribute("data-dark-mode", "true");
    } else {
      root.removeAttribute("data-dark-mode");
    }
  }, [isDarkModeEnabled]);

  return null;
}
